import React from 'react'
import {VictoryAxis, VictoryTheme, VictoryLine, VictoryChart, VictoryScatter} from 'victory'
import PropTypes from 'prop-types'
export default class CharCoordinates extends React.Component {

  render () {
    let width = parseInt(this.props.width) || 300
    let height = parseInt(this.props.height) || 300
    const {afectoX, afectoY} = this.props.vector
    let size = width * 8 / 300
    let data = [
      { x: 0, y: 0 },
      { x: afectoX, y: afectoY }]
    let sizeScatter = width * 5 / 300
    let fontSize = width * 14 / 300
    let dataScatter = [{ x: afectoX, y: afectoY }]
    let strokeWidthLine = width * 0.8 / 300
    let difference = 360 - width
    let padding = (width / 2.9) - (difference/10)
    return (
        <div id='AfectoCoordinates'>
            <svg style={{ parent: { maxWidth: '50%' } }} width={width} height={height}>
            <VictoryChart width={width} height={height}>
              <VictoryAxis crossAxis
                domain={[-10, 10]}
                theme={VictoryTheme.material}
                standalone={false}
                tickValues={[-10, -8, -6, -4, -2, 0, 2, 4, 6, 8, 10]}
                style={{
                  ticks: {
                    stroke: 'white', 
                    padding
                  },
                  tickLabels: {
                    fontSize: size,
                    fill: 'white'
                  },
                  axis: {
                    stroke: 'white',
                    strokeWidth: strokeWidthLine
                  },
                  grid: {
                    stroke: 'rgba(255,255,255,.3)',
                    strokeDasharray: '3,1'
                  }
                }}
                />
                <VictoryAxis dependentAxis crossAxis
                domain={[-10, 10]}
                theme={VictoryTheme.material}
                standalone={false}
                tickValues={[-10, -8, -6, -4, -2, 0, 2, 4, 6, 8, 10]}
                style={{
                  ticks: {
                    stroke: 'white',
                    padding
                  },
                  tickLabels: {
                    fontSize: size,
                    fill: 'white'
                  },
                  axis: {
                    stroke: 'white',
                    strokeWidth: strokeWidthLine
                  },
                  grid: {
                    stroke: 'rgba(255,255,255,.3)',
                    strokeDasharray: '3,1 '
                  }
                }}
                />
                <VictoryLine data={data}
                  labelOrientation="top"
                  style={{ data: { stroke: 'white', strokeWidth:1 } }}
                />
                <VictoryScatter
                  size={sizeScatter}
                  data={dataScatter}
                  labels={(datum) => `(${datum.x}, ${datum.y})`}
                  style={{ labels: { padding: 5, fill: 'white', strokeWidth: 0.1, stroke: 'white', fontSize: fontSize }, data: { fill: "#c43a31" } }}
                ></VictoryScatter>
            </VictoryChart>
            </svg>
        </div>
    )
  }
}

CharCoordinates.propTypes = {
  vector: PropTypes.object,
  width: PropTypes.any,
  height: PropTypes.any
}



// WEBPACK FOOTER //
// ./src/components/Patient/Component/CharCoordinates.js